// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { __ } from '../../../../i18n/l10n';
import theme from '../../../../styled-components/dark';
import { withOpacity } from '../../../../styled-components/dark/helpers';
import GiftRaceBasketIcon from '../../assets/img/gr_basket_toggle_icon.png';

const Wrapper = styled.div`
  ${({ $isCompact }) =>
    $isCompact
      ? css`
          display: inline-block;
          font-size: 0.8em;
        `
      : null}

  ${({ $isDisabled }) =>
    $isDisabled
      ? css`
          opacity: 0.5;
        `
      : null}
`;

const Content = styled.div`
  border-radius: 0.4em;

  ${({ $isCompact, $dark }) =>
    $isCompact
      ? css`
          display: flex;
          gap: 0.3em;
          padding: 0.2em 0.3em;
          background: ${$dark
            ? theme.DarkEligibleHeadband.backgroundColor
            : theme.KLBasketBetslipEligible.backgroundColor};
        `
      : css`
          position: relative;

          padding: 0.3em 3em;
          background-image: ${theme.KLBasketBetslipEligible.backgroundColor};
        `}
`;

const Label = styled.div`
  font-family: 'BettingArchivoNarrow';
  font-weight: bold;

  ${({ $isCompact, $dark }) =>
    $isCompact
      ? css`
          color: ${$dark ? theme.DarkEligibleHeadband.color : theme.KLBasketBetslipEligible.color};
        `
      : css`
          width: 100%;

          text-align: center;
          color: ${withOpacity(theme.KLBasketBetslipEligible.color, 'b2')};
        `}
`;

const Icon = styled.img`
  width: 1.3em;

  ${({ $isCompact }) =>
    !$isCompact
      ? css`
          position: absolute;
          left: 0.9em;
          top: 50%;
          transform: translateY(-50%);
        `
      : null}
`;

type GRBetslipEligibleHeadbandProps = {
  className?: string;
  isCompact?: boolean;
  dark?: boolean;
  isDisabled?: boolean;
};

const GRBetslipEligibleHeadband = ({ className = '', isCompact, dark, isDisabled }: GRBetslipEligibleHeadbandProps) => {
  return (
    <Wrapper className={className} $isCompact={isCompact} $isDisabled={isDisabled}>
      <Content $isCompact={isCompact} $dark={dark}>
        <Icon src={GiftRaceBasketIcon} $isCompact={isCompact} />
        <Label $isCompact={isCompact} $dark={dark}>
          {__('The Gift Race')}
        </Label>
      </Content>
    </Wrapper>
  );
};

export default GRBetslipEligibleHeadband;
